import { baseParams } from "../common";
import { ContentType, request } from "../api";

/** Лёгкий статус заказа для опроса после оплаты: бек отвечает из своей базы, без запроса в ads_v1. */
export const getOrderStatus = async (data = {}) => {
  const response = await request({
    path: "/order-status",
    method: "POST",
    body: { ...baseParams, ...data },
    type: ContentType.Json,
    format: "json",
    secure: true,
  });

  return response?.data;
};
